import { z } from 'zod';

export const audienceSchema = z.enum(['public', 'customer', 'owner', 'admin']);
export type Audience = z.infer<typeof audienceSchema>;
